<div class="form-input">
    <mat-checkbox class="example-margin"
    [color]="color"
    [formControlName]="formControlName">
    {{text}}
</mat-checkbox>
</div>